import BrodBandMainComp from "../../components/brodband/BrodBandMainComp"

export const BroadbandReportPage = ({ title_1, title_2, title }) => {
   
    return <div>
        <BrodBandMainComp title_1={title_1} title_2={title_2} title={title} />
    </div>
}



